<template>
  <div>
    <div class="page-content">
      <div class="frame-content">
        <el-row>
          <div class="click-text" @click="toHome">
            返回首页
          </div>
        </el-row>
        <el-row style="margin-top: 30px; height: 550px; text-align: center;">
          <div style="font-size: 50px; font-weight: 600; margin-top: 150px;">
            404
          </div>
          <div style="
              font-size: 40px;
              color: #9e9e9e;
              font-weight: 600;
              margin-top: 30px;
            ">
            页面不存在
          </div>
        </el-row>
      </div>
    </div>
    <!--  底部   -->
    <div style="width: 100%;  background-color:#0E919B;">
      <footer-gray></footer-gray>
    </div>
  </div>
</template>

<script>
import FooterGray from './FooterGray'

export default {
  data () {
    return {
      isError: true,
      loginForm: {}
    }
  },
  components: {
    FooterGray
  },
  methods: {
    toHome () {
      this.$router.push("/")
    }
  }
}
</script>

<style scoped>
.page-content {
  background-color: #e9e9e9;
  width: 100%;
  margin: auto;
}

.click-text {
  text-decoration: underline;
  color: #0E919B;
  cursor: pointer;
  font-weight: 600;
  margin-top: 70px;
  margin-left: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/frame/NotFound.vue